// Config for Voucher payout
export const voucherPayout = false;
export const voucherPremiumPercentage = 20;

// Config for price setting
export const userCanSetPrice = false;
